import { Link } from "react-router-dom";
import { useCart } from "@/App";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const ArtworkCard = ({ artwork, index = 0 }) => {
  const { addToCart } = useCart();

  const handleAddToCart = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const success = await addToCart({
      artwork_id: artwork.id,
      title: artwork.title,
      price: artwork.price,
      image_url: artwork.image_url,
      quantity: 1,
    });

    if (success) {
      toast.success(`${artwork.title} added to cart`);
    } else {
      toast.error("Failed to add to cart");
    }
  };

  const seasonColors = {
    spring: "bg-spring",
    summer: "bg-summer",
    fall: "bg-fall",
    winter: "bg-winter",
  };

  return (
    <Link
      to={`/artwork/${artwork.id}`}
      className="group block animate-fade-in"
      style={{ animationDelay: `${index * 0.1}s` }}
      data-testid={`artwork-card-${artwork.id}`}
    >
      <div className="relative overflow-hidden bg-muted/30">
        <img
          src={artwork.image_url}
          alt={artwork.title}
          className="aspect-square object-contain w-full bg-muted/10 transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
        
        {/* Quick add button */}
        <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <Button
            onClick={handleAddToCart}
            className="w-full rounded-none px-6 py-2 bg-primary-foreground text-primary hover:bg-primary-foreground/90 uppercase tracking-widest text-xs font-bold"
            data-testid={`add-to-cart-${artwork.id}`}
          >
            Add to Cart
          </Button>
        </div>

        {/* Featured badge */}
        {artwork.is_featured && (
          <span className="absolute top-4 left-4 bg-primary text-primary-foreground px-3 py-1 text-xs uppercase tracking-widest">
            Featured
          </span>
        )}

        {/* Season badge */}
        <span className={`absolute top-4 right-4 ${seasonColors[artwork.season]} px-3 py-1 text-xs uppercase tracking-widest text-foreground`}>
          {artwork.season}
        </span>
      </div>

      <div className="mt-4 flex justify-between items-start">
        <div>
          <h3 className="font-serif text-lg group-hover:text-primary/70 transition-colors">
            {artwork.title}
          </h3>
          <p className="text-sm text-muted-foreground mt-1">{artwork.artist}</p>
        </div>
        <p className="font-medium">${artwork.price.toFixed(2)}</p>
      </div>
    </Link>
  );
};

export default ArtworkCard;
